import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useLoaderData, useSearchParams } from '@remix-run/react';
import { setupMockDateOnce } from './utils.ts';

const DEFAULT_MOCK_DATE = '2024-03-17 13:30:00';

/**
 * Manages EPG mock mode and mock date from URL search parameters.
 * @returns {{ isMock: boolean; mockDate: Date }} Mock mode status and parsed date
 */
export const useMockEpg = () => {
  const { isMock } = useLoaderData<any>();
  const mockDate = useSearchParams()[0].get('mockDate') || DEFAULT_MOCK_DATE;

  const [mockDateDate, setMockDate] = useState(new Date(mockDate));

  useEffect(() => {
    setMockDate(new Date(mockDate));
  }, [mockDate]);

  const isMockModeInitializedRef = useRef(false);

  useLayoutEffect(() => {
    setupMockDateOnce(isMock, mockDate, isMockModeInitializedRef);
  }, [isMock, mockDate]);

  return { isMock, mockDate: mockDateDate };
};
